import React from 'react';
import {Typography} from '@mui/material';
import {POTS_CASH} from '../../../utils/potsFilter';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {usePlanValidationLevel} from '../CreateBuilder/BuilderSourceDestination/usePlanValidationLevel';
import {BuilderContributeSourceFields} from './BuilderContributeSourceFields';

interface ContributeCashSourceRowProps {
  contributeFromId?: string;
  handleChange: () => void;
}

export const ContributeCashSourceRow: React.FC<ContributeCashSourceRowProps> = ({
  contributeFromId,
  handleChange,
}) => {
  const isSelected = contributeFromId === POTS_CASH;
  const activeFormikKey = isSelected ? 'contribute.contributeFrom' : undefined;
  const {bgClass} = usePlanValidationLevel(activeFormikKey);

  return (
    <PlanRow id={POTS_CASH} reccId={null} isSelected={isSelected} isSubplan={false}>
      <PlanAccordionShell
        expanded={isSelected}
        isSelected={isSelected}
        isSoleParent
        validationLevel={bgClass}
        summaryChildren={
          <>
            <PlanSelector
              mode="single"
              id={POTS_CASH}
              isSelected={isSelected}
              handleChange={handleChange}
            />
            <Typography>New cash contribution</Typography>
          </>
        }
        summaryTrailing={
          activeFormikKey ? (
            <PlanValidationIcon formikKeyPrefix={activeFormikKey} />
          ) : undefined
        }
      >
        <BuilderContributeSourceFields />
      </PlanAccordionShell>
    </PlanRow>
  );
};
